<template>
  <div>
    <div v-if="matrix" class="matrix">
      <div :id="name" class="mtx">
        <template v-if="dimensions">
          <div
            v-for="dot in filteredItems"
            :key="`${name}-filtered-${dot.id}`"
            class="marker"
            @click="getDot(dot)"
            :style="getPosition(dot)"
          >
            <div
              class="marker__circle"
              :class="dot.color"
              :style="getOffset(dot)"
            >
              <div class="marker__label" :style="getLabelPosition(dot)">
                {{ dot.title }}
              </div>
            </div>
            <div
              class="marker__repeats"
              v-if="dot.repeats > 1 && dot.repeatStep === 1"
            >
              <div class="chip">{{ dot.repeats }}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="axis axis__x" v-if="!reference">
        <p>{{ axis1.from }}</p>
        <div></div>
        <p>{{ axis1.to }}</p>
      </div>
      <div class="axis axis__y" v-if="!reference">
        <p>{{ axis2.from }}</p>
        <div></div>
        <p>{{ axis2.to }}</p>
      </div>
    </div>
    <div v-if="debug">
      <v-row>
        <v-col cols="6">
          <pre>
          {{ filteredItems }}
          </pre>
        </v-col>
        <!-- <v-col cols="6">
          <pre>
            {{ positions }}
          </pre>
        </v-col> -->
      </v-row>
      <pre></pre>
    </div>
  </div>
</template>

<script>
// const fb = require("@/firebaseConfig.js");
import lodash from 'lodash'

export default {
  name: 'UserCompetitionMatrix',
  data() {
    return {
      dimensions: null,
      conflicts: [],
      positions: [],
      repeats: [],
      debug: false
    }
  },
  props: {
    matrix: {
      type: Object,
      default: () => ({})
    },
    filter: String,
    editMode: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    reference: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 3
    },
    min: {
      type: Number,
      default: -3
    },
    name: {
      type: String,
      default: ''
    },
    axis1: {
      type: Object,
      default: () => ({
        from: '',
        to: ''
      })
    },
    axis2: {
      type: Object,
      default: () => ({
        from: '',
        to: ''
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
    const vm = this
    window.addEventListener('resize', lodash.throttle(vm.init, 300))
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.init, false)
  },
  watch: {
    editMode: {
      immediate: true,
      handler() {
        this.init()
      }
    },
    full: {
      handler() {
        this.init()
      }
    },
    matrix: {
      deep: true,
      handler() {
        this.init()
      }
    }
  },
  computed: {
    filteredItems() {
      const arr = []
      this.positions.forEach(a => {
        const lookup = this.positions.filter(b => b.x === a.x && b.y === a.y)
        // push the current lookup into array so we can count index number
        let repeatItems
        if (lookup.length > 1) {
          this.repeats.push({ id: a.id, x: a.x, y: a.y })
          // see how many items match criteria
          repeatItems = this.repeats.filter(
            item => item.x === a.x && item.y === a.y
          ).length
        } else {
          repeatItems = 1
        }

        arr.push({
          ...a,
          repeats: lookup.length,
          repeatStep: repeatItems
        })
      })
      return arr
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.getDimensions()
        this.getPositions()
      })
    },
    getDot(dot) {
      if (!this.reference) {
        this.$emit('editItemMatrix', dot)
      }
    },
    getDimensions() {
      const div = document.getElementById(this.name)
      console.log('div name', div)
      if (div) {
        const rect = div.getBoundingClientRect()
        console.log('rect', rect)
        this.dimensions = {
          width: rect.width,
          height: rect.height,
          originX: rect.width / 2,
          originY: rect.height / 2,
          steps: Math.abs(this.min) + Math.abs(this.max) + 1
        }
      }
    },
    getPositions() {
      // console.log("get positions", this.filter);
      this.positions = []
      this.conflicts = []
      this.repeats = []
      // const all = [...this.matrix.q1, ...this.matrix.q2, ...this.matrix.q3];
      if (this.filter) {
        Object.values(this.matrix).forEach(value => {
          if ('id' in value) {
            this.getPoint(value, this.filter)
          }
        })
      } else {
        Object.entries(this.matrix).forEach(([key, value]) => {
          value.forEach(item => {
            if ('id' in item) {
              this.getPoint(item, key)
            }
          })
        })
      }
    },

    getPoint(point, list) {
      let obj

      if ('scale' in point) {
        const unitX = this.dimensions.originX / this.max
        const unitY = this.dimensions.originY / this.max
        const left = Math.floor(
          this.dimensions.originX + -unitX * point.scale.axis1
        )
        const top = Math.floor(
          this.dimensions.originY + -unitY * point.scale.axis2
        )
        obj = {
          ...point,
          x: left,
          y: top,
          left: `${left}px`,
          top: `${top}px`,
          list
        }
      } else {
        obj = {
          ...point,
          x: this.dimensions.originX,
          y: this.dimensions.originY,
          left: `${this.dimensions.originX}px`,
          top: `${this.dimensions.originY}px`,
          list
        }
      }
      this.positions.push(obj)
    },

    getPosition(point) {
      const item = this.filteredItems.find(x => x.id === point.id)
      if (item) {
        return { left: `${item.x}px`, top: `${item.y}px` }
      } else {
        return {}
      }
    },

    getOffset(point) {
      const item = this.filteredItems.find(x => x.id === point.id)
      // console.log("list", point.list);
      if (item) {
        let offsetX, offsetY
        const radius = 20
        const containerRadius = 20
        const originX = -containerRadius / 2 + 5
        const originY = -containerRadius / 2 + 5
        if (point.repeats > 1) {
          const unit = (Math.PI * 2) / point.repeats
          const unitRadius = radius + point.repeats
          offsetX = originX + Math.sin(point.repeatStep * unit) * unitRadius
          offsetY = originY + Math.cos(point.repeatStep * unit) * unitRadius
        } else {
          offsetX = originX
          offsetY = originY
        }
        return { left: `${offsetX}px`, top: `${offsetY}px` }
      } else {
        return {}
      }
    },

    getLabelPosition(point) {
      if ('scale' in point) {
        let style = ''
        if (point.list === 'q5') {
          point.scale.axis1 > 0 ? (style += 'translateX(-120%)') : (style += '')
          point.scale.axis2 > 0 ? (style += 'translateY(-150%)') : (style += '')
        } else {
          point.scale.axis1 > 0 ? (style += 'translateX(-100%)') : (style += '')
          point.scale.axis2 > 0 ? (style += 'translateY(-150%)') : (style += '')
        }

        return { transform: style }
      } else {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.matrix {
  position: relative;
  width: 100%;
  min-height: 75vh;
  overflow: visible;
  // border: 1px solid red;
}
.marker {
  position: absolute;
  top: 0px;
  left: 0px;
  // transition: all 0.3s ease-out;
  &__circle {
    position: absolute;
    width: 10px;
    height: 10px;
    // top: 50%;
    // left: 50%;
    border-radius: 50%;
    background: white;
    transition: all 0.3s ease-out;
    &.large {
      width: 30px;
      height: 30px;
      // top: 50%;
      // left: 50%;
      transform: translate(-50%, -50%);
      .marker__label {
        transform: translate(20%, 120%);
      }
    }
    z-index: 1;
    &:hover {
      cursor: pointer;
      z-index: 999;
      .marker__label {
        background: black;
        z-index: 999;
        opacity: 1;
        font-size: 18px;
      }
    }
  }
  &__label {
    position: absolute;
    padding: 2px;
    font-size: 10px;
    top: 10px;
    left: 0;
    width: auto;
    white-space: nowrap;
    transform: translate(100% 100%);
    z-index: 0;
    opacity: 0.4;
  }
  &__repeats {
    position: relative;
    .chip {
      position: absolute;
      width: 25px;
      height: 25px;
      border: 1px dotted white;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 15px;
      background: #303030;
      z-index: 1;
    }
  }
}
.mtx {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}
.axis {
  display: flex;
  position: absolute;
  &__x {
    flex-direction: row;
    align-items: center;
    transform: translateY(-50%);
    top: 50%;
    width: 100%;
    p {
      padding: 0 10px;
      margin: 0;
      font-weight: bold;
      color: #888;
    }
    div {
      flex: 5;
      height: 1px;
      width: 100%;
      background: white;
    }
  }
  &__y {
    flex-direction: column;
    align-items: center;
    transform: translateX(-50%);
    left: 50%;
    height: 100%;
    p {
      padding: 0 10px;
      margin: 0;
      font-weight: bold;
      color: #888;
    }
    div {
      flex: 5;
      width: 1px;
      height: 100%;
      background: white;
    }
  }
}
</style>
